package ui.login

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import globalCoroutineExceptionHandler
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import kotlin.time.Clock.System
import model.DataRepository
import model.LoginResponse
import model.NavigationRepository
import navigation.NavigationState
import org.koin.compose.koinInject
import stripNonNumbers
import ui.DisposableViewModel
import ui.ScopeHolderFactory

@Composable
fun loginViewModel(
    scopeHolderFactory: ScopeHolderFactory = koinInject(),
): LoginViewModel {
    val scopeHolder = remember { scopeHolderFactory.getOrCreate(LoginViewModel::class) }
    DisposableEffect(Unit) { onDispose { scopeHolder.detach() } }
    return remember { scopeHolder.attach() }
}

class LoginViewModel(
    private val dataRepository: DataRepository,
    private val navigationRepository: NavigationRepository,
) : ViewModel(), DisposableViewModel {

    private val phoneNumberMutableStateFlow = MutableStateFlow("")
    val phoneNumberState = phoneNumberMutableStateFlow.asStateFlow()

    private val isButtonEnableMutableStateFlow = MutableStateFlow(false)
    val isButtonEnableStateFlow = isButtonEnableMutableStateFlow.asStateFlow()

    private val countryCodeMutableStateFlow = MutableStateFlow(1)
    val countryCodeStateFlow = countryCodeMutableStateFlow.asStateFlow()

    var lastClickTime = 0L

    init {
        println("LoginViewModel has been created!")
    }

    fun updatePhoneNumber(phoneNumber: String) {
        var formattedPhoneNumber = phoneNumber.stripNonNumbers()
        if (formattedPhoneNumber.length > 10) {
            formattedPhoneNumber = formattedPhoneNumber.substring(0, 10)
        }
        phoneNumberMutableStateFlow.value = formattedPhoneNumber
        isButtonEnableMutableStateFlow.value = formattedPhoneNumber.length >= 10
    }

    fun submitPhoneNumber(onSubmitted: () -> Unit = {}) {
        val currentTime = System.now().toEpochMilliseconds()
        if (isButtonEnableStateFlow.value) {
            if ((currentTime - lastClickTime) < DEBOUNCEINTERVAL) {
                return
            }
            lastClickTime = currentTime
            onSubmitted()
            setSubmitted()
            val phoneNumberWithCountryCode = "${countryCodeStateFlow.value}${phoneNumberState.value}"
            val validatedPhoneNumber = phoneNumberWithCountryCode.toLongOrNull()
            if (validatedPhoneNumber != null) {
                viewModelScope.launch(globalCoroutineExceptionHandler + Dispatchers.Default) {
                    val tokenResponse = dataRepository.submitPhoneNumber(validatedPhoneNumber)
                    when (tokenResponse) {
                        is LoginResponse.Submitted -> Unit
                        is LoginResponse.BypassLogin -> dataRepository.bypassLogin(tokenResponse.token)
                        is LoginResponse.Error -> Unit
                    }
                }
            }
        }
    }

    fun countryCodeSelected(countryCode: Int) {
        countryCodeMutableStateFlow.value = countryCode
    }

    fun setSubmitted() {
        navigationRepository.navigate(NavigationState.LoginSubmitted())
    }

    override fun dispose() {
        println("LoginViewModel.dispose()")
    }

    companion object {
        const val DEBOUNCEINTERVAL = 5000L
    }
}